export const updateNotification = (payload: any) => ({
    type: "@saga/UPDATE_NOTIFICATION",
    payload
});